<div
  #dropdown
  class="dropdown"
  [class.disabled]="disabled"
  [class.placeholder]="!disabled && !_.selectedDisplay"
  [class.error]="error"
  [class.warning]="warning"
  [attr.tabindex]="disabled ? null : 0"
  (click)="!disabled && _.setIsOpen(!_.isOpen)"
  [focusOnInit]="autoFocus"
>
  <ng-container *ngIf="loadable && (loadable.loading || loadable.erred)">
    <span class="display">
      <span class="display-value">&nbsp;</span>
    </span>
    <loadable class="loading" [size]="16" [data]="loadable"></loadable>
  </ng-container>
  <ng-container *ngIf="!loadable || (!loadable.loading && !loadable.erred)">
    <span class="display">
      <span class="selected-count" *ngIf="_.selectedCount > 1">
        {{ _.selectedCount }}
      </span>
      <span class="display-value" [title]="_.selectedDisplay">
        {{ _.selectedDisplay || placeholder || '&nbsp;' }}
      </span>
    </span>
  </ng-container>
  <div class="chevron">
    <riv-icon [name]="'ChevronDown'" [size]="16"></riv-icon>
  </div>
</div>
<ng-container *ngIf="_.isOpen && !disabled">
  <deprecated-callout
    *deprecated-callout
    class="callout"
    [class.filterable]="filterable"
    [anchor]="dropdown"
    fallbackDirection="cw"
    [allowedPositions]="topAndBottomPositions"
    (actualPosition)="_.setPosition($event)"
    (close)="_.setIsOpen(false)"
    [scrollable]="false"
    [calloutHeight]="400"
  >
    <div
      class="callout-inner rv-card rv-rows"
      [style.min-width.px]="dropdownWidth"
      [style.max-height.px]="_.maxHeight"
      #callout
    >
      <multi-select
        #options
        class="select rv-rows rv-grow"
        [disabled]="disabled"
        [displayId]="displayId"
        [exact]="exact"
        [filterable]="filterable"
        [filterPositionBottom]="_.positionedTop"
        [options]="_options"
        [selectedOptionIds]="selectedOptionIds"
        (selectedOptionIdsChange)="selectedOptionIdsChange.emit($event)"
        (filterChange)="filter.next($event)"
        [selectedEnabled]="selectedEnabled"
        [anchor]="dropdown"
        [maxElements]="maxElements"
      ></multi-select>
      <ng-content></ng-content>
      <div class="rv-card-footer rv-grid">
        <div class="rv-column-6 rv-left">
          <button
            *ngFor="let button of _.displayLeftButtons"
            class="rv-footer-button"
            rivButton
            [variant]="button.type ?? 'ghost'"
            [size]="'small'"
            (click)="button.onClick()"
          >
            {{ button.text }}
          </button>
        </div>
        <div class="rv-column-6 rv-right">
          <button
            *ngFor="let button of _.displayRightButtons"
            class="rv-footer-button"
            rivButton
            [variant]="button.type ?? 'ghost'"
            [size]="'small'"
            (click)="button.onClick()"
          >
            {{ button.text }}
          </button>
        </div>
      </div>
    </div>
  </deprecated-callout>
</ng-container>
